(() => {
    const checkPriceComponent = {
        template: '#mainCheckPrice',
        props: ['check', 'clientcode', 'cartsended'],
        emits: ['cart-sent'],
        computed: {
            computedCheck() {
                console.log('%cVue %ccheckPriceComponent %ccomputedCheck()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                return calcCheckSummary(this.check);
            }
        },
        methods: {
            sendToCart() {
                console.log('%cVue %ccheckPriceComponent %csendToCart()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA');
                sendCheckToCart(this.check);
                this.$emit('cart-sent');
                window.dispatchEvent(new CustomEvent('complect-cart-sent'));
            },
            locateToCart() {
                console.log('%cVue %ccheckPriceComponent %clocateToCart()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                window.location = '/cart/';
            }
        }
    }

    if (typeof Vue !== 'undefined') {
        const checkApp = Vue.createApp({
            data() {
                return {
                    check: window.check,
                    cartsended: false,
                    clientcode: window.clientcode
                }
            },
            methods: {
                updateCheck(newcheck) {
                    console.log('%cVue %ccheckApp %cupdateCheck()', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                    this.check = newcheck;
                },
                cartSended() {
                    console.log('%cVue %ccheckApp %ccartSended() true', 'color: #52BE7C', 'color: #9CDCFE', 'color: #DCDCAA')
                    this.cartsended = true;
                }
            }
        });

        checkApp.component('main-check-price', checkPriceComponent);
        window.checkApp = checkApp.mount('#checkApp');

        window.addEventListener('complect-check-updated', e => window.checkApp.updateCheck(e.detail));
        window.addEventListener('complect-cart-sent',    () => window.checkApp.cartSended());
    }

    $('#staticCheck').remove();
})()
